/**
 * Script pour ajouter un texte défilant dans le drawer de navigation mobile
 */
document.addEventListener('DOMContentLoaded', function() {
  // Attendre que tous les styles soient chargés
  setTimeout(function() {
    addScrollingTextToDrawer();
    
    // Observer les changements pour s'assurer que le texte défilant est présent après les interactions utilisateur
    const observer = new MutationObserver(function(mutations) {
      const drawerPlaceholder = document.querySelector('[data-countdown-placeholder]');
      if (drawerPlaceholder && drawerPlaceholder.children.length === 0) {
        addScrollingTextToDrawer();
      }
    });
    
    // Observer le document pour les changements dans le DOM
    observer.observe(document.body, { childList: true, subtree: true });
  }, 500);
  
  function addScrollingTextToDrawer() {
    // Vérifier si le drawer existe
    const drawerPlaceholder = document.querySelector('[data-countdown-placeholder], .drawer__countdown-placeholder');
   // console.log('Recherche du placeholder:', drawerPlaceholder);
    
    if (drawerPlaceholder) {
      // Récupérer le texte depuis la section scrolling-text
      const scrollingTextSection = document.querySelector('.scrolling-text-section');
      const scrollingText = scrollingTextSection ? scrollingTextSection.querySelector('.scrolling-text') : null;
      
     // console.log('Section scrolling-text:', scrollingTextSection);
     // console.log('Élément scrolling-text:', scrollingText);
      
      if (!scrollingText) {
      //  console.log('Section scrolling-text non trouvée');
        return;
      }
      
      // Récupérer les styles de l'original
      const sectionStyles = window.getComputedStyle(scrollingTextSection);
      const sectionBackground = scrollingTextSection.querySelector('.section');
      const sectionBackgroundStyles = sectionBackground ? window.getComputedStyle(sectionBackground) : null;
      const textElement = scrollingText.querySelector('.scrolling-text__item');
      const textStyles = textElement ? window.getComputedStyle(textElement) : null;
      
      // Déterminer la couleur de fond
      let backgroundColor = 'rgb(var(--color-background))'; // Valeur par défaut
      let textColor = 'rgb(var(--color-text))'; // Valeur par défaut
      
      // Essayer de récupérer la couleur de fond dans cet ordre :
      // 1. Background de la section elle-même
      // 2. Background du premier élément avec la classe .section
      // 3. Variable CSS du thème
      if (sectionStyles.backgroundColor && sectionStyles.backgroundColor !== 'rgba(0, 0, 0, 0)') {
        backgroundColor = sectionStyles.backgroundColor;
      } else if (sectionBackgroundStyles && sectionBackgroundStyles.backgroundColor !== 'rgba(0, 0, 0, 0)') {
        backgroundColor = sectionBackgroundStyles.backgroundColor;
      }
      
      // Récupérer la couleur du texte
      if (textStyles && textStyles.color) {
        textColor = textStyles.color;
      } else if (sectionStyles.color) {
        textColor = sectionStyles.color;
      }
      
     // console.log('Couleur de fond trouvée:', backgroundColor);
     // console.log('Couleur du texte trouvée:', textColor);
      
      // Créer un conteneur avec le fond
      const container = document.createElement('div');
      container.className = 'drawer-scrolling-container py-3';
      
      // Appliquer les styles
      container.style.backgroundColor = backgroundColor;
      container.style.color = textColor;
      
      // Cloner le texte défilant
      const clonedText = scrollingText.cloneNode(true);
      
      // Ajuster les styles pour le drawer
      clonedText.style.transform = 'scale(0.85)';
      
      // S'assurer que tous les éléments de texte ont la bonne couleur
      clonedText.querySelectorAll('.scrolling-text__item').forEach(item => {
        item.style.color = textColor;
      });
      
      // Ajuster l'espacement
      const marqueeElements = clonedText.querySelectorAll('.marquee');
      marqueeElements.forEach(marquee => {
        marquee.style.gap = '3.5rem'; // Augmenter l'espacement entre les éléments
        marquee.style.padding = '0.5rem 0'; // Ajouter du padding vertical
      });
      
      // Ajouter au drawer
      container.appendChild(clonedText);
      drawerPlaceholder.innerHTML = '';
      drawerPlaceholder.appendChild(container);
    }
  }
}); 